import {
  actionButtonNavigationConfigType,
  ActionButtonOutcomesType,
  defaultNavigationConfig,
} from '../action-button-navigation-config.type';
import { ButtonActionType } from '../common.type';

export const transactionNavigationConfigMap: Map<ButtonActionType, actionButtonNavigationConfigType> =
  new Map([
    [
      ButtonActionType.SAVE_TRANSACTION_NOTE,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.EDIT_TRANSACTION_NOTE,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
      },
    ],
  ]);
